export default "__VITE_ASSET__D4bu8rEW__"